<script lang="ts" setup>
import { DialogHeader, DialogTitle, DialogDescription, DialogFooter, DialogClose } from '~/components/ui/dialog'
import { Button } from '~/components/ui/button'

const { t } = useI18n()
const emit = defineEmits(['next', 'close'])
const globalStore = useGlobalStore()
const jobtokenRulesPage = computed(() => {
	if(!globalStore.rule_pages.jobtoken?.documentId) return
	return {
		name: 'page',
		params: {
			id: globalStore.rule_pages.jobtoken?.documentId,
		},
	}
})
</script>

<template>
	<div class="p-4">
		<div class="text-center">
			<video 
				src="/img/jobtoken/logo-present.webm" 
				class="mx-auto mb-6 aspect-video object-cover" 
				autoplay 
				muted 
				playsinline
			></video>

			<DialogHeader>
				<DialogTitle class="text-lg font-bold">
					{{ t('Congratulations!') }}
				</DialogTitle>
				<DialogDescription v-if="jobtokenRulesPage" class="text-sub mb-6">
					You’ve earned a JOB reward! To redeem it, link your TON Wallet. You can learn more about JobToken and reward rules <NuxtLink :to="jobtokenRulesPage" class="text-primary-900" @click="emit('close')">here</NuxtLink> or in your <NuxtLink :to="{ name: 'office_profile' }" class="text-primary-900" @click="emit('close')">Profile Settings</NuxtLink>.
				</DialogDescription>
				<DialogDescription v-else class="text-sub mb-6">
					You’ve earned a JOB reward! To redeem it, link your TON Wallet. You can learn more about JobToken in your <NuxtLink :to="{ name: 'office_profile' }" class="text-primary-900" @click="emit('close')">Profile Settings</NuxtLink>.
				</DialogDescription>
			</DialogHeader>

			<DialogFooter class="flex flex-col gap-4">
				<DialogClose class="w-full" as-child>
					<Button variant="outline" class="w-full">
						{{ $t('Later') }}
					</Button>
				</DialogClose>

				<Button @click="emit('next')" variant="primary" class="w-full">
					{{ $t('Learn more') }}
				</Button>
			</DialogFooter>
		</div>
	</div>
</template>

